import store from '@/store'
const ss = require("@/services/socket");
const is_localhost = require("@/utils").default.is_localhost;
const scrollDown = require("@/utils").default.scrollDown;
const customLogger = require("@/utils").customLogger;

const showBox = () => {
  store.commit('SHOW_BOX')
  window.localStorage.setItem('cleed_showBox', 'true')
}

async function get_products(content) {
  for (let [key, value] of Object.entries(content)) {
    if (content[key] && (key == 'grid' || key == 'carousel')) {
      if ((content[key].mode == 'explore' || content[key].mode == 'filter') && content[key].already_explored) {
        content[key].values = content[key].already_explored
      } else if (content[key].mode == 'explore' || content[key].mode == 'filter') {
        content[key].values = [
          { picture_url: 'https://thumbs.gfycat.com/EvilMisguidedFieldmouse-small.gif' },
          { picture_url: 'https://thumbs.gfycat.com/EvilMisguidedFieldmouse-small.gif' },
          { picture_url: 'https://thumbs.gfycat.com/EvilMisguidedFieldmouse-small.gif' },
          { picture_url: 'https://thumbs.gfycat.com/EvilMisguidedFieldmouse-small.gif' },
        ]
        const res = await store.dispatch('GET_RECOMMENDATION', {
          filter: value.mode == 'filter',
          component_type: key,
          popularity: store.state.config.steps[store.state.user.style_profile_key].carousel.popularity,
          product_seen_reco: store.state.config.steps[store.state.user.style_profile_key].carousel.product_seen_reco
        })

        content[key].values.splice(0, content[key].values.length)

        if (res != null) {
          const product_ids = res.map(p => p['product_id'])
          store.dispatch('PRODUCT_SEEN', product_ids)

          for (let i = 0; i < res.length; i++) {
            content[key].values.push(res[i])
          }
          setTimeout(() => {
            scrollDown()
          }, 100)
        } else {
          content[key].values = []
          content['message'] = value.mode == 'filter' ? 'chat.notfound' : 'chat.notfound2'
          if (store.state.config.storeId == 33 || store.state.config.storeId == 49) {
            content['message'] = "chat.other"
            content['buttons'] = [
              {
                "name": "no_thanks.retry",
                "value": "new"
              }
            ]
            content['condition'] = {
              "new": "gender"
            }
          }
        }
      }
    } else if (content[key] && key == 'look') {
      if (content[key].mode == 'explore' && content[key].already_explored) {
        // content[key].values = content[key].already_explored
      } else if (content[key].mode == 'explore') {
        content[key].values = {
          picture_url: [
            'https://thumbs.gfycat.com/EvilMisguidedFieldmouse-small.gif'
          ],
          product_ids: [],
          down: {
            type: "products",
            values: [
              { picture_url: 'https://thumbs.gfycat.com/EvilMisguidedFieldmouse-small.gif' },
              { picture_url: 'https://thumbs.gfycat.com/EvilMisguidedFieldmouse-small.gif' },
              { picture_url: 'https://thumbs.gfycat.com/EvilMisguidedFieldmouse-small.gif' },
              { picture_url: 'https://thumbs.gfycat.com/EvilMisguidedFieldmouse-small.gif' },
            ],
          }
        }

        const res = await store.dispatch('GET_LOOK')

        if (res != undefined) {
          content[key].values.picture_url.splice(0, content[key].values.picture_url.length)
          content[key].values.picture_url.push(res.picture_url)
          content[key].values.product_ids = res.product_ids

          if (res.down) {
            content[key].values.down.values.splice(0, content[key].values.down.values.length)
            for (let i = 0; i < res.down.length; i++) {
              content[key].values.down.values.push(res.down[i])
            }
          }
        }
      }
    }
  }
  return content
}

function emit_message({ message, notif = false, slack = false, dialogflow = false, commit = false, sender = 'self', cb = null, is_first_proposition= undefined, should_send_dialogflow = false, url, ignoreGpt = false, typing = false, questionCounter = 0, logger }) {
  let question = false;

  if (commit) {
    const At = new Date();
    const send = {
      sender_type: sender,
      content: message,
      sent_at: At.toISOString(),
      typing_indicator: typing
    }
    store.commit('PUSH_MESSAGE', send)
  }
  store.commit('INC_MSG_SESSION');
  customLogger(`le message : |${message}|`)
  if(message === "D'autres sujets" || message === "Rester ici" || message === "chat.help" || message == 'Other subjects' || message == 'Remain here' || message == 'I have an other question' || message == "J'ai une autre question") {
    customLogger('--> question ----> : ' , question, store.state.config.storeId);
    question = true;
  }
  if((message === "J'ai une question" || message === "I have a question" || message === "chat.help") && (store.state.config.storeId != 25 && store.state.user.storeId != 46 && store.state.config.storeId != 43)) {
    question = true
    customLogger('--> question : ' , question, store.state.config.storeId);
  }
  customLogger(store.state.user.messages)
  let nb_msg_rcvd = store.state.user.messages.length
  ss.socket.emit('message', {
    "guid": store.state.user.guid,
    "id": ss.socket.id,
    "msg": message,
    "store_id": store.state.config.storeId,
    "gender": store.state.user.data.gender,
    "mode": store.state.navigation.mode,
    "lang": store.state.user.lang,
    "notif": is_localhost() ? false : notif,
    "slack": is_localhost() ? false : slack,
    "dialogflow": dialogflow,
    "sender": sender,
    "is_first_proposition": is_first_proposition,
    "should_send_dialogflow": should_send_dialogflow,
    "url": url,
    "ignoreGpt": ignoreGpt,
    "nb_msg_rcvd" : nb_msg_rcvd,
    "msg_from_part": store.state.navigation.mode,
    "i_have_question" : question,
    "questionCounter": questionCounter,
    logger
  }, () => {
    if (cb != null)
      cb()
  })
}

export default {
  showBox,
  get_products,
  emit_message
}
